import React from 'react';
import './OperationCard.css';

const OperationCard = ({ operation }) => {
  // Функция для форматирования даты
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('ru-RU', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  };

  // Функция для форматирования суммы
  const formatAmount = (amount, currency) => {
    const formattedAmount = new Intl.NumberFormat('ru-RU', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);
    
    const sign = operation.operation_type === 'deposit' ? '+' : '-';
    return `${sign}${formattedAmount} ${currency}`;
  };

  // Функция для получения названия операции
  const getOperationName = (type) => {
    switch (type) {
      case 'deposit':
        return 'Пополнение';
      case 'withdrawal':
        return 'Вывод';
      default:
        return 'Операция';
    }
  };

  // Функция для получения описания операции
  const getOperationDescription = (operation) => {
    // Для торговых счетов отображаем номер счета из account_number
    if (operation.account_type === 'trading' && operation.account_number) {
      return `счет ${operation.account_number}`;
    }
    
    // Для банковских счетов или если нет account_number, используем recipient_details
    if (operation.recipient_details) {
      const details = typeof operation.recipient_details === 'string' 
        ? JSON.parse(operation.recipient_details) 
        : operation.recipient_details;
      
      if (operation.operation_type === 'deposit') {
        return `на ${details.accountNumber || 'счет'}`;
      } else if (operation.operation_type === 'withdrawal') {
        return `на ${details.number || 'счет'}`;
      }
    }
    
    return operation.comment || 'Операция';
  };

  // Функция для получения типа CSS класса
  const getTypeClass = (type) => {
    switch (type) {
      case 'deposit':
        return 'income';
      case 'withdrawal':
        return 'withdraw';
      default:
        return 'income';
    }
  };

  // Функция для получения иконки статуса
  const getStatusIconClass = (status) => {
    switch (status) {
      case 'created':
        return 'count__name-status--icon-clock';
      case 'processing':
        return 'count__name-status--icon-loading';
      case 'completed':
        return 'count__name-status--icon-check';
      case 'rejected':
        return 'count__name-status--icon-close';
      default:
        return 'count__name-status--icon-clock';
    }
  };

  // Функция для получения текста статуса
  const getStatusText = (status) => {
    switch (status) {
      case 'created':
        return ' Создан';
      case 'processing':
        return ' В обработке';
      case 'completed':
        return ' Завершен';
      case 'rejected':
        return ' Отклонен';
      default:
        return ' Создан';
    }
  };

  const typeClass = getTypeClass(operation.operation_type);

  return (
    <a 
      href="#" 
      data-fls-block="" 
      data-fls-number="" 
      className="body-history__count count count--hover"
    >
      <div className={`count__main count__main--condition-${typeClass} count__main--icon-condition`}>
        <div className="count__content">
          <h5 className="count__title count__title--title-20">
            {getOperationDescription(operation)}
          </h5>
          <div className="count__name">
            <span className="count__name-text">{getOperationName(operation.operation_type)}</span>
            {operation.comment && operation.comment !== 'Operation created by admin' && operation.comment !== 'Вывод средств' && (
              <span className="count__name-comment">• {operation.comment} •</span>
            )}
            <span className={`count__name-status ${getStatusIconClass(operation.status)}`}>
              {getStatusText(operation.status)}
            </span>
          </div>
        </div>
      </div>
      <div className={`count__result count__result--${typeClass}`}>
        <span>{formatAmount(operation.amount, operation.currency)}</span>
      </div>
    </a>
  );
};

export default OperationCard;